/**
 * roleMapping Normalizr Schema
 */

import { schema } from 'normalizr';

import role from './role';

export const getIdAttribute = (value: Value) =>
    `${value.email}.${value.roleId}`;

const roleMapping = new schema.Entity(
    'roleMappings',
    {
        role
    },
    {
        idAttribute: getIdAttribute
    }
);

export default roleMapping;
